import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import useGalleryImages from "../hooks/useGalleryImages";

export default function Slider() {
  const { images, loading, error } = useGalleryImages({ featured: true });

  if (loading) return <div className="w-full max-w-4xl mx-auto h-96" />;
  if (error || images.length === 0) return null;

  return (
    <div className="w-full max-w-4xl mx-auto py-8">
      <Swiper
        spaceBetween={30}
        centeredSlides={true}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
        }}
        navigation={true}
        modules={[Autoplay, Navigation]}
        className="rounded-lg shadow-md"
      >
        {images.map((image) => (
          <SwiperSlide key={image.id}>
            <img
              src={image.src}
              alt={image.alt}
              className="w-full h-96 object-cover rounded-lg"
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}
